<template>
  <BreadCrumb PageTitle="Gestion des villes" />
  <CitiesSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CitiesSettings from "../../components/Generals/Zones/CitiesSettings.vue";

export default defineComponent({
  name: "CitiesSettingsPage",
  components: {
    BreadCrumb,
    CitiesSettings,
  },
});
</script>